import { render, staticRenderFns } from "./basicTabUICustomLayout.vue?vue&type=template&id=69061155&"
import script from "./basicTabUICustomLayout.vue?vue&type=script&lang=js&"
export * from "./basicTabUICustomLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69061155')) {
      api.createRecord('69061155', component.options)
    } else {
      api.reload('69061155', component.options)
    }
    module.hot.accept("./basicTabUICustomLayout.vue?vue&type=template&id=69061155&", function () {
      api.rerender('69061155', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaImport/components/SiBooking/tabs/basicTabUICustomLayout.vue"
export default component.exports